if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.makeEndWith
) {
  Object.defineProperty(String.prototype, 'makeEndWith', {
    value(ending) {
      return this.endsWith(ending) ? this : `${this}${ending}`;
    }
  });
}